<template>
    <div id = 'dashboard'>

      <!-- <div class="row yellow">
        <div class="col s12 pink" style="">
          <ul class="tabs DashboardTabsHeight teal"> 
            <li class="tab col s2"><a href="#overview">overview</a></li>
            <li class="tab col s2"><a href="#europe">europe</a></li>
            <li class="tab col s2"><a href="#germany">germany</a></li>
            <li class="tab col s3"><a href="#brandPerformanceOverview">brand performance</a></li>
            <li class="tab col s3"><a href="#brandPlatformPerformance">brand platform performance</a></li>
        
            <li class="tab col s3"><a href="#brandPerformanceJungheinrich">jungheinrich</a></li>
            <li class="tab col s3"><a href="#brandPerformanceStill">still</a></li>
            <li class="tab col s3"><a href="#brandPerformanceLinde">linde</a></li>
            <li class="tab col s3"><a href="#brandPerformanceToyota">toyota</a></li>
          </ul>
        </div>

        <div id="overview" class="col s12 green">
         

          <vue-friendly-iframe class="red" src="https://datastudio.google.com/embed/reporting/3e5acfb7-3a4c-40f1-b05a-d8342b72b3d6/page/NFWh" @load="onLoad"></vue-friendly-iframe>
        </div>

        <div id="europe" class="col s12">
          <iframe width="120" height="900" 
            src="https://datastudio.google.com/embed/reporting/06abb17e-32cf-4a1b-a5b5-99d70cebd41f/page/nEOi" 
            frameborder="0"                       
            allowfullscreen>
          </iframe>
        </div>

        <div id="germany" class="col s12">
          <iframe width="120" height="900" 
              src="https://datastudio.google.com/embed/reporting/222ffe51-ad19-4c7b-bea8-12fa2ce15d7c/page/keTi" 
              frameborder="0"                         
              allowfullscreen>
          </iframe>
        </div>

        <div id="brandPerformanceOverview" class="col s12">
          <iframe width="120" height="900" 
              src="https://datastudio.google.com/embed/reporting/33ef1fcd-dee1-40bc-b321-751ba0ca64f8/page/u5I3" 
              frameborder="0"                        
              allowfullscreen>
          </iframe>
        </div>

        <div id="brandPlatformPerformance" class="col s12">
          <iframe width="120" height="900" 
              src="https://datastudio.google.com/embed/reporting/ddf6bd9c-8652-417a-ac75-41d29166c999/page/4WP3" 
              frameborder="0"                        
              allowfullscreen>
          </iframe>
        </div>

        <div id="brandPerformanceJungheinrich" class="col s12">
          <iframe width="600" height="450" src="https://datastudio.google.com/embed/reporting/9aedb20f-a4c9-4316-a7f5-22d45f58f3a2/page/YaOv" frameborder="0" style="border:0" allowfullscreen></iframe>
        </div>

        <div id="brandPerformanceStill" class="col s12">
          <iframe width="120" height="900" 
              src="https://datastudio.google.com/embed/reporting/44c57f6e-c03c-4720-b49f-6c7398a93fd6/page/u5I3" 
              frameborder="0"                        
              allowfullscreen>
          </iframe>
        </div>

        <div id="brandPerformanceLinde" class="col s12">
          <iframe width="120" height="900" 
              src="https://datastudio.google.com/embed/reporting/7483e8e8-02a8-45b3-95d6-8d66151ab681/page/u5I3" 
              frameborder="0"                       
              allowfullscreen>
          </iframe>
        </div>

        <div id="brandPerformanceToyota" class="col s12">
          <iframe width="600" height="450" src="https://datastudio.google.com/embed/reporting/28545f25-9771-4681-bdc4-a2720acb668b/page/DJOv" frameborder="0" style="border:0" allowfullscreen></iframe>
        </div>

      </div> -->

      <div class="row">
        <div class="col s12">
          <iframe class=""
            src="https://datastudio.google.com/embed/reporting/3e5acfb7-3a4c-40f1-b05a-d8342b72b3d6/page/NFWh" 
            frameborder="0"                       
            allowfullscreen>
          </iframe>
        </div>
      </div>
 
    </div>            
</template>

<script src="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/js/materialize.min.js"></script>

<script>
import firebase from "firebase";
import fb from "../components/firebaseInit";
export default {
    name: 'dashboard',
    data(){
        return {
            dashboardtoggle: null
        }
    },

    created(){
      const currentUserUID = firebase.auth().currentUser.uid
      const currentUserDoc = fb.collection("user").doc(currentUserUID);

      currentUserDoc.get().then((doc) =>  {
        if (doc.exists) {
          this.dashboardtoggle = doc.data().dashboard
          if (this.dashboardtoggle == false) {
            this.$router.replace("/user");
          }
        } else {
            console.log("No such document!");
        }        
      }).catch(function(error) {
            console.log("Error getting document:", error);
      });
    },

    mounted(){
        var elems = document.querySelectorAll('.tabs');
        var instances = M.Tabs.init(elems, {});
    }
}
</script>